import { MenuService } from '../../services/menu.service';
import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
//import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';

@Component({
    selector: 'app-closed-modal',
    templateUrl: './closed-modal.component.html',
    styleUrls: ['./closed-modal.component.scss'],
    standalone: false
})
export class ClosedModalComponent implements OnInit {
  @Input() orderType: string;
  @Input() fromDesktop: boolean;
  constructor(
    private modalCtrl: ModalController,
    //public translateService: TranslateService
    ) { }

  ngOnInit() {
   
  }
 
  cancel() {
    localStorage.removeItem('editKey');
    this.modalCtrl.dismiss({
      cancel: true
    });

}
}
